// initial state
// shape: [{ id, quantity }]
const state = {
  options: {
    city_level: [
      {label: '一线城市', value: 1},
      {label: '新一线城市', value: 2},
      {label: '二线城市', value: 3},
      {label: '三线城市', value: 4},
      {label: '四线城市', value: 5},
      {label: '五线城市', value: 6},
    ],
    market_size: [
      {label: '大卖场', value: 1},
      {label: '大型超市', value: 2},
      {label: '小超市', value: 3},
      {label: '便利店', value: 4},
      {label: '其他', value: 5},
    ],
    is_chain: [
      {label: '否', value: 0},
      {label: '是', value: 1},
    ],
    map_type: [
      {label: '百度', value: 0},
      {label: '高德', value: 1},
    ],
    status: [
      {label: '正常营业', value: 1},
      {label: '闭店', value: 10},
      {label: '查无此店', value: 20},
    ],
    isee: [
      {label: '否', value: 0},
      {label: '是', value: 10},
    ],
    markettype: [
      {label: 'NKA', value: 10, disabled: true},
      {label: '大型连锁综合超市', value: 11},
      {label: '大型独立综合超市', value: 12},
      {label: 'LKA', value: 70, disabled: true},
      {label: '精品超市', value: 80},
      {label: '中型超市', value: 20},
      {label: '生鲜超市', value: 21},
      {label: '小型超市', value: 22},
      {label: '连锁便利店', value: 30},
      {label: '日用食杂店', value: 31},
      {label: '水果店', value: 32},
      {label: '粮油店', value: 33},
      {label: '烟酒专卖店', value: 34},
      {label: '快时尚百货', value: 35},
      {label: '母婴店', value: 40},
      {label: '加油站便利店', value: 50},
      {label: '百货商场', value: 100},
      {label: '休闲娱乐场所', value: 150, disabled: true},
      {label: '酒吧', value: 151},
      {label: '网吧', value: 152},
      {label: 'KTV', value: 153},
      {label: '服装饰品', value: 154},
      {label: '文具用品', value: 165},
      {label: '医药用品店', value: 90},
      {label: '私营小店', value: 130, disabled: true},
      {label: '餐饮店', value: 180},
      {label: '宠物店', value: 200},
      {label: '数码家电', value: 210},
      {label: '美妆护理店', value: 220},
      {label: '私营卖场', value: 230, disabled: true},
      {label: '健身场所', value: 240},
      {label: '汽配修理', value: 250},
      {label: '楼宇大厦', value: 260},
      {label: '宴席(2)', value: 92},
      {label: '其他', value: 60},
    ],
    gatherinfo_status: [
      {label: '不收集', value: 1},
      {label: '待收集', value: 2},
      {label: '收集中', value: 3},
      {label: '收集完成', value: 4},
      {label: '信息确认', value: 5, disabled: true},
    ],
    areatype: [
      {label: '未知', value: 0},
      {label: '1000-2000m²', value: 1},
      {label: '500-1000m²', value: 2},
      {label: '300-500m²', value: 3},
      {label: '小于300m²', value: 4},
    ],
    freezerStatus: [
      {label: '未知', value: 0},
      {label: '两者都有', value: 1},
      {label: '有冷柜无冷藏', value: 2},
      {label: '有冷藏无冷柜', value: 3},
      {label: '两者都无', value: 4},
    ],
    storeStatus: [
      {label: '未知', value: 0},
      {label: '天猫小店', value: 1},
      {label: '苏宁小店', value: 2},
      {label: '京东便利店', value: 3},
      {label: '其他', value: 4},
    ]
  },

}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {}

// mutations
const mutations = {}

export const market = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/market/market.store.js